import { KibAccountCircleIcon } from '@chewy/kib-icons-react';
import styles from './CircleImages.module.scss';

export interface CircleImageItem {
  id?: string;
  src: string;
  alt?: string;
}

export interface CircleImagesProps {
  images?: CircleImageItem[];
  maxVisible?: number;
}

export default function CircleImages({ images = [], maxVisible = 2 }: CircleImagesProps) {
  const hasImages = images.length > 0;
  const imagesToShow = images.slice(0, maxVisible);
  const remainingCount = images.length > maxVisible ? images.length - maxVisible : 0;

  return (
    <div className={styles.imagesContainer}>
      {hasImages ? (
        <>
          {imagesToShow.map((image, index) => (
            <img
              key={image.id || index}
              src={image.src}
              alt={image.alt || 'Image'}
              className={styles.image}
              style={{ zIndex: imagesToShow.length - index }}
            />
          ))}
          {remainingCount > 0 && (
            <div className={styles.countBadge}>
              {`+${remainingCount}`}
            </div>
          )}
        </>
      ) : (
        <div className={styles.placeholder} aria-hidden="true">
          <KibAccountCircleIcon />
        </div>
      )}
    </div>
  );
}
